import CustomComponent from "../../components/customComponent";
import { withToast } from "../../App";
import hoistStatics from "hoist-non-react-statics";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../components/withRouter";
import { BoaterLayout } from "../../components/Layouts";
import TerminalMap from "../terminal/_TerminalMap";
import DynamicModal from "../../components/DynamicModal";
import LightBulbIcon from "../../assets/img/icons/lightbulb-info.svg";
import ChargeTypeIcon from "../../assets/img/icons/charge-type.svg";
import ChargeElectricityIcon from "../../assets/img/icons/charge-electricity.svg";
import ChargeWaterIcon from "../../assets/img/icons/charge-water.svg";
import MapIcon from "../../assets/img/icons/map-outline.svg";
import { withBoaterStorage } from "../../hooks/useBoaterStorage";
import VisuelRef from "../../assets/img/visuel-ref.png";
import Dropdown from "../../components/Dropdown";
import { getConnectorStatusClass } from "../../helpers/connectorStatusHelpers";

class BoaterProcessStep1 extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            terminal: null,
            terminalConnectors: null,
            terminalConnectorsCount: null,
            terminals: [],
            search: "",
            userPosition: null,
            isLoading: false,
            isTerminalModalOpen: false,
            modalPage: 1,
            manualUrl: null,
        };
    }

    async componentDidMount() {
        await this.logoutIfLoggedIn();
        this.shouldReopenModal =
            this.props.boaterStorage.boater_return_to_modal === true;
        await this.getTerminals();
        if (this.shouldReopenModal) {
            this.reopenTerminalModal();
            this.props.updateBoaterStorage({
                boater_return_to_modal: false,
            });
        } else {
            this.onGeolocateClick();
        }
    }

    reopenTerminalModal = async () => {
        this.setState({ isLoading: true });

        try {
            const terminal = {
                id: this.props.boaterStorage.terminalId,
                cpoTerminalId: this.props.boaterStorage.terminalName,
            };

            await this.handleMarkerClick(terminal);

            setTimeout(() => {
                this.setState({ modalPage: 2 });
            }, 100);
        } catch (error) {
            console.error("Error reopening terminal modal:", error);
            this.setState({ isLoading: false });
        }
    };

    handleMarkerClick = async (terminal) => {
        this.setState({ isLoading: true });
        const { t } = this.props;

        const url = `/terminal/${terminal.id}`;

        const terminalInfo = await this.request(url, "GET");

        if (
            !terminalInfo ||
            !terminalInfo.terminal ||
            terminalInfo.status !== "ok"
        ) {
            this.setState({
                isLoading: false,
            });
            return;
        }

        const connectorsCount = {
            electricity: {},
            water: {},
        };
        const connectorsData = {
            electricity: [],
            water: [],
        };

        terminalInfo.terminal.connectors
            .toSorted((a, b) => a.position - b.position)
            .forEach((connector) => {
                if (connector.disabled) return;

                if (
                    !connector.metadata ||
                    !connector.metadata.label ||
                    connector.metadata.label.length === 0
                ) {
                    connector.metadata = {
                        label: `${
                            connector.fluidType === "Electricity"
                                ? t("Electricity")
                                : t("Water")
                        }-${connector.position}`,
                    };
                }

                const capacity = connector.capacity;
                if (connector.fluidType === "Electricity") {
                    connectorsData.electricity.push(connector);
                    if (!connectorsCount.electricity[capacity]) {
                        connectorsCount.electricity[capacity] = 1;
                    } else {
                        connectorsCount.electricity[capacity] += 1;
                    }
                } else if (connector.fluidType === "Water") {
                    connectorsData.water.push(connector);
                    if (!connectorsCount.water[capacity]) {
                        connectorsCount.water[capacity] = 1;
                    } else {
                        connectorsCount.water[capacity] += 1;
                    }
                }
            });

        this.setState({
            terminal: terminalInfo.terminal,
            terminalConnectors: connectorsData,
            terminalConnectorsCount: connectorsCount,
            isTerminalModalOpen: true,
            isLoading: false,
            manualUrl: terminalInfo.manual_url,
        });
    };

    async getTerminals() {
        this.setState({ isLoading: true });

        const url = "/terminal/map";
        const data = await this.request(url, "GET");

        if (data?.map) {
            const terminals = Object.keys(data.map)
                .filter(
                    (key) =>
                        data.map[key].gpsLat !== undefined &&
                        data.map[key].gpsLon !== undefined &&
                        data.map[key].status !== "Offline",
                )
                .map((key) => ({
                    ...data.map[key],
                    name: data.map[key].cpoTerminalId,
                }));
            this.setState({ terminals });
        }

        this.setState({ isLoading: false });
    }

    nextModalPage = () => {
        this.setState({ modalPage: 2 });
    };

    prevModalPage = () => {
        this.setState({ modalPage: 1 });
    };

    nextSubStep = (selectedConnector) => {
        this.props.updateBoaterStorage({
            terminalId: this.state.terminal.id,
            connectorId: selectedConnector.id,
            connectorLabel: selectedConnector.metadata.label,
            terminalName: this.state.terminal?.cpoTerminalId,
            manualUrl: this.state.manualUrl,
            hasElectricity: this.state.terminal.hasElectricity,
            hasWater: this.state.terminal.hasWater,
            currentEnergyType: selectedConnector.fluidType,
        });

        this.props.navigate("/boater/step1-2");
    };

    geolocSuccess = (currentPosition) => {
        this.setState({
            userPosition: {
                lat: currentPosition.coords.latitude,
                lon: currentPosition.coords.longitude,
            },
        });
    };

    geolocError = (error) => {
        if (error.code === error.PERMISSION_DENIED) {
            console.info(error.message, { code: error.code });
            return;
        }
        const { t } = this.props;
        this.props.addToast(t("geolocate_fail"), { appearance: "danger" });
        console.error(error.message, { code: error.code });
    };

    onGeolocateClick = () => {
        navigator.geolocation.getCurrentPosition(
            this.geolocSuccess,
            this.geolocError,
            {
                maximumAge: 0,
                timeout: 5000,
                enableHighAccuracy: true,
            },
        );
    };

    onModalClose = (keepFocus = false) => {
        this.setState({ isTerminalModalOpen: false });

        // delay modal state reset to avoid content movement while it is closing
        setTimeout(() => {
            this.setState({
                ...(!keepFocus && { terminal: null }),
                modalPage: 1,
                terminalConnectors: null,
                terminalConnectorsCount: null,
            });
        }, 350);
    };

    render() {
        const { t } = this.props;

        const renderConnectors = (fluidType, icon, title, plugLabel) => {
            let connectors = this.state.terminalConnectors?.[fluidType];
            if (
                !this.state.terminal?.[
                    `has${fluidType.charAt(0).toUpperCase() + fluidType.slice(1)}`
                ] ||
                !connectors
            ) {
                return null;
            }

            connectors = [...connectors].sort((a, b) => {
                const getPosition = (connector, idx) => {
                    const label = connector.metadata?.label || "";
                    const match = label.match(/N°\s*(\d+)/);
                    return match ? parseInt(match[1], 10) : idx + 1;
                };
                return getPosition(a, 0) - getPosition(b, 0);
            });

            return (
                <div className="boater-step1__terminal-details__connectors">
                    <h3>
                        <img
                            src={icon}
                            alt=""
                            width={fluidType === "electricity" ? "18" : "20"}
                            height="28"
                        />
                        {t(title)}
                    </h3>
                    <ul>
                        {connectors.map((connector, idx) => {
                            let position = null;
                            const label = connector.metadata?.label || "";
                            const match = label.match(/N°\s*(\d+)/);
                            if (match) {
                                position = match[1];
                            } else {
                                position = idx + 1;
                            }
                            return (
                                <li key={connector.id}>
                                    <button
                                        type="button"
                                        disabled={
                                            getConnectorStatusClass(
                                                connector.status,
                                            ) !== "available"
                                        }
                                        onClick={() =>
                                            this.nextSubStep(connector) &&
                                            this.props.history.push(
                                                "/boater/step1-2",
                                            )
                                        }
                                    >
                                        <p className="position">N°{position}</p>
                                        <p className="plug">
                                            {t(plugLabel)}
                                            {fluidType === "electricity" && (
                                                <> {connector.capacity}</>
                                            )}
                                        </p>
                                        <p
                                            className={`status status--${getConnectorStatusClass(connector.status)}`}
                                        >
                                            {t(connector.status)}
                                            <span />
                                        </p>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        };

        return (
            <BoaterLayout step={1} loading={this.state.isLoading}>
                <div className="boater__step-container">
                    <TerminalMap
                        onMarkerClick={this.handleMarkerClick}
                        onGeolocClick={this.onGeolocateClick}
                        terminals={this.state.terminals}
                        focusedTerminal={this.state.terminal}
                        userPosition={this.state.userPosition}
                        hideMobile={false}
                        hideLegend={true}
                        hideGeoloc={false}
                        boaterMarkers={true}
                        grow={true}
                        fitToMarkerBoundsOnLoad={false}
                        enableClustering={true}
                        enableScrollWheelZoom={true}
                    />
                </div>

                <DynamicModal
                    open={this.state.isTerminalModalOpen}
                    onClose={() => this.onModalClose()}
                    extraClasses={{ content: "boater-step1__terminal-details" }}
                >
                    <div className="boater-step1__terminal-details__header">
                        <img
                            src={LightBulbIcon}
                            width="46"
                            height="60"
                            alt=""
                        />
                        <h2>
                            <span>{t("terminal")} </span>
                            <span>{this.state.terminal?.cpoTerminalId}</span>
                            <Dropdown buttonText={t("find_reference")}>
                                <div>
                                    <img
                                        src={VisuelRef}
                                        width="215"
                                        height="130"
                                        alt=""
                                    />
                                </div>
                            </Dropdown>
                        </h2>
                    </div>
                    {/* page 1 = terminal confirm */}
                    {this.state.modalPage === 1 && (
                        <>
                            <div className="boater-step1__terminal-details__body">
                                {(Boolean(
                                    this.state.terminal?.hasElectricity,
                                ) ||
                                    Boolean(this.state.terminal?.hasWater)) && (
                                    <h3 className="boater-step1__terminal-details__plug-intro">
                                        <img
                                            src={ChargeTypeIcon}
                                            alt=""
                                            width="41"
                                            height="28"
                                        />
                                        <span>
                                            {t("available_from_terminal")}
                                        </span>
                                    </h3>
                                )}
                                {Boolean(this.state.terminal?.hasElectricity) &&
                                    this.state.terminalConnectorsCount
                                        ?.electricity && (
                                        <div className="boater-step1__terminal-details__plug-list">
                                            <p>
                                                <img
                                                    src={ChargeElectricityIcon}
                                                    alt=""
                                                    width="18"
                                                    height="28"
                                                />
                                                <span>{t("ELECTRICITE")}</span>
                                            </p>
                                            <ul>
                                                {Object.keys(
                                                    this.state
                                                        .terminalConnectorsCount
                                                        .electricity,
                                                ).map((key) => (
                                                    <li key={key}>
                                                        <span>
                                                            {
                                                                this.state
                                                                    .terminalConnectorsCount
                                                                    .electricity[
                                                                    key
                                                                ]
                                                            }
                                                        </span>
                                                        <span>
                                                            {t(
                                                                "plugs_electricity",
                                                            )}{" "}
                                                            {key}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                {Boolean(this.state.terminal?.hasWater) &&
                                    this.state.terminalConnectorsCount
                                        ?.water && (
                                        <div className="boater-step1__terminal-details__plug-list">
                                            <p>
                                                <img
                                                    src={ChargeWaterIcon}
                                                    alt=""
                                                    width="20"
                                                    height="28"
                                                />
                                                <span>{t("EAU")}</span>
                                            </p>
                                            <ul>
                                                {Object.keys(
                                                    this.state
                                                        .terminalConnectorsCount
                                                        .water,
                                                ).map((key) => (
                                                    <li key={key}>
                                                        <span>
                                                            {
                                                                this.state
                                                                    .terminalConnectorsCount
                                                                    .water[key]
                                                            }
                                                        </span>
                                                        <span>
                                                            {t("plugs_water")}
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                            </div>
                            <div className="boater-step1__terminal-details__footer">
                                <div className="boater-step1__terminal-details__prev">
                                    <h3>
                                        <img
                                            src={MapIcon}
                                            alt=""
                                            width="41"
                                            height="41"
                                        />
                                        <span>{t("cta_callout")}</span>
                                    </h3>
                                    <div>
                                        <button
                                            type="button"
                                            className="vnf-btn vnf-btn-quaternary-outline vnf-btn-quaternary-outline--thinner"
                                            onClick={() =>
                                                this.onModalClose(true)
                                            }
                                        >
                                            {t("locate_terminal")}
                                        </button>
                                        <button
                                            type="button"
                                            className="vnf-btn vnf-btn-quaternary-outline vnf-btn-quaternary-outline--thinner"
                                            onClick={() => this.onModalClose()}
                                        >
                                            {t("change_terminal")}
                                        </button>
                                    </div>
                                </div>
                                <div className="boater-step1__terminal-details__next">
                                    <button
                                        type="button"
                                        className="vnf-btn vnf-btn-quaternary vnf-btn-quaternary--thinner vnf-btn-quaternary-arrow"
                                        onClick={this.nextModalPage}
                                        disabled={
                                            !(
                                                this.state.terminal
                                                    ?.hasElectricity ||
                                                this.state.terminal?.hasWater
                                            )
                                        }
                                    >
                                        {t("connect_to_terminal")}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}

                    {/* page 2 = connector choice */}
                    {this.state.modalPage === 2 && (
                        <>
                            <div className="boater-step1__terminal-details__body">
                                <div className="boater-step1__terminal-details__connectors-title">
                                    <button
                                        type="button"
                                        className="vnf-icons-icon-m-fleche-b-gauche-outline"
                                        onClick={this.prevModalPage}
                                    ></button>
                                    <p>{t("start_with")}</p>
                                </div>
                                <p className="boater-step1__terminal-details__connectors-intro">
                                    {t("complete_later")}
                                </p>
                                {renderConnectors(
                                    "electricity",
                                    ChargeElectricityIcon,
                                    "ELECTRICITE",
                                    "plug_electricity",
                                )}
                                {renderConnectors(
                                    "water",
                                    ChargeWaterIcon,
                                    "EAU",
                                    "plug_water",
                                )}
                            </div>
                        </>
                    )}
                </DynamicModal>
            </BoaterLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(withBoaterStorage(BoaterProcessStep1))),
        BoaterProcessStep1,
    ),
);
